// import { useState } from 'react';
// import Link from 'next/link';
// import { allRowsRequired } from '@/utils/validation';
import { ViewWrapper, SinglePageWrapper, ContentWrapper } from '@/styles/index';
import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import HeadMeta from '@/components/HeadMeta';
import TemplatesBanner from '@/components/Templates';
import TemplateGrid from '@/components/Templates/TemplateGrid';
import CTABig from '@/components/Layout/CTABig';
import { useSession } from 'next-auth/client';
import dynamic from 'next/dynamic';

const Footer = dynamic(() => import('@/components/Layout/Footer'));

const Templates = () => {
  // const [selected, setSelected] = useState(() => MODELS.find(it => it.id === 'rating'));
  const [session] = useSession();
  return (
    <ViewWrapper>
      <HeadMeta
        title="Templates – Explore and customize starter templates from Pollme"
        description="Explore Poll & Micro-Survey templates, pick some starter, modify it, and you are ready to go!"
      />
      <Navbar session={session} />
      <SinglePageWrapper>
        <TemplatesBanner />
        <ContentWrapper>
          <TemplateGrid />
        </ContentWrapper>
      </SinglePageWrapper>
      <CTABig />
      <Footer />
    </ViewWrapper>
  );
};

export default Templates;
// https://react-hook-form.com/api/#register
// for input rules

// const INPUT_QST = {
//   id: 'rxdtcfygvubhijn',
//   type: 'input',
//   inputType: 'text', // default "text"
//   name: 'input-base',
//   title: '**What** is _it_?',
//   validation: {
//     minLength: {
//       value: 5
//       // message: 'Por favor, ingresa mas de 5 caracteres'
//     },
//     required: {
//       value: true
//     }
//   }
// };

// const NUMBER_QST = {
//   id: 'h678657hjklnkbjh',
//   type: 'input',
//   inputType: 'number', // default "text"
//   name: 'input-number-base',
//   title: 'Pick a number',
//   validation: {
//     required: {
//       value: true
//     },
//     min: {
//       value: 0
//       // message: 'Min value is: 0'
//     },
//     max: {
//       value: 10
//       // message: 'Max value is: 10'
//     }
//   },
//   helper: 'Value range from 0 to 10'
// };

// const TEXTAREA_QST = {
//   id: 'vg65767',
//   type: 'textarea',
//   name: 'textarea-base',
//   title: 'comments?',
//   validation: {
//     required: { value: true },
//     maxLength: {
//       value: 140,
//       message: 'Max 140 caracteres' // JS only: <p>error message</p> TS only support string
//     }
//   },
//   helper: 'Write what you want!'
// };

// const NATIVE_DATE_QST = {
//   id: 'hjgvj09809kll',
//   type: 'input',
//   inputType: 'date', // default "text"
//   name: 'input-native-date',
//   title: 'Pick a html native date',
//   validation: {
//     required: {
//       value: true
//     }
//   }
// };
// const DATE_INLINE__QST = {
//   id: 'uhjb2343',
//   type: 'date',
//   name: 'date-base-inline',
//   title: 'Pick a date',
//   validation: {
//     required: {
//       value: true
//     }
//   },
//   // component props: https://reactdatepicker.com/
//   // for a full list: https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md
//   // and https://github.com/Hacker0x01/react-datepicker/blob/master/docs/time.md
//   showTimeSelect: true,
//   timeIntervals: 15, // in mins
//   locale: 'es',
//   timeCaption: 'Hora',
//   inline: true
//   // showYearDropdown: true
// };
// const DATE_QST = {
//   id: 'kplmlkmkl',
//   type: 'date',
//   name: 'date-base',
//   title: 'Pick a date',
//   validation: {
//     required: {
//       value: true
//     }
//   },
//   // component props: https://reactdatepicker.com/
//   // for a full list: https://github.com/Hacker0x01/react-datepicker/blob/master/docs/datepicker.md
//   // and https://github.com/Hacker0x01/react-datepicker/blob/master/docs/time.md
//   showTimeSelect: true,
//   timeIntervals: 15, // in mins
//   locale: 'es',
//   timeCaption: 'Hora'
//   // inline: true
// };

// const LIKERT_QST = {
//   id: 'fg65rfgh65',
//   type: 'buttons',
//   name: 'likert-base',
//   title: 'form 1 to 5,....',
//   cols: 5,
//   options: [
//     { id: 'dsa', value: 1, label: 'One' },
//     { id: 'dsd', value: 2, label: 'Two' },
//     { id: 'dss', value: 3, label: 'Three' },
//     { id: 'dsr', value: 4, label: 'Four' },
//     { id: 'dsh', value: 5, label: 'Five' }
//   ],
//   validation: {
//     required: {
//       value: true
//       // message: 'dsfdsf'
//     },
//     validate: value => value === 1 || 'Select "One"' // custom validate fn
//   },
//   labelsTop: ['Left', 'center', 'Right'],
//   labelsBottom: ['', 'center', '']
// };

// const SELECT_QST = {
//   id: 'zwewrxrdtfc5465',
//   type: 'dropdown',
//   name: 'select-base',
//   title: 'pick one form dropdown...',
//   options: [
//     { id: 'dda', value: 'chocolate', label: 'Chocolate' },
//     { id: 'dga', value: 'strawberry', label: 'Strawberry' },
//     { id: 'dja', value: 'vanilla', label: 'Vanilla' }
//   ],
//   // more select props as isCreatable, etc
//   validation: {
//     required: { value: true }
//   }
// };
// const RATING3_QST = {
//   id: 'mkkjnkj876876',
//   type: 'rating',
//   variant: 'heart',
//   name: 'rating-three',
//   title: 'Please rate us 3',
//   ratingMax: 3,
//   validation: {
//     required: { value: true },
//     setValueAs: value => parseInt(value) // custom post manipulation data as validation step (before onSubmit)
//   }
// };
// const RATING_QST = {
//   id: 'jhbh7887888',
//   type: 'rating',
//   variant: 'star',
//   name: 'rating-base',
//   title: 'Please rate us 5',
//   showValues: true, // default true, as values under slider
//   ratingMax: 5, // range 3 to 10
//   validation: {
//     required: { value: true },
//     setValueAs: value => parseInt(value) // custom post manipulation data as validation step (before onSubmit)
//   }
//   // labelsTop: ['To the left', 'center', 'To the right']
// };
// const RATING7_QST = {
//   id: 'hjh54345',
//   type: 'rating',
//   variant: 'star',
//   name: 'rating-7',
//   title: 'Please rate us 7',
//   ratingMax: 7,
//   validation: {
//     required: { value: true },
//     setValueAs: value => parseInt(value) // custom post manipulation data as validation step (before onSubmit)
//   }
// };
// const RATING10_QST = {
//   id: 'wqzwe45',
//   type: 'rating',
//   variant: 'star',
//   name: 'rating-10',
//   title: 'Please rate us 10',
//   ratingMax: 10,
//   validation: {
//     required: { value: true },
//     setValueAs: value => parseInt(value) // custom post manipulation data as validation step (before onSubmit)
//   }
// };

// const SLIDER_QST = {
//   id: 'hgfvhgjvhjvjh6',
//   type: 'slider',
//   name: 'slider-base',
//   title: 'Please rate us',
//   ratingMax: 7,
//   showValues: true, // default true, as values under slider
//   min: 0, // issues with slider at 0 when range [-10 to 10] e.g.
//   max: 50,
//   step: 2,
//   markers: [10, 20, 30, 40],
//   validation: {
//     required: { value: true },
//     validate: value => value >= 20 || 'Value must be equal or greater than 20' // custom validate fn
//   },
//   labelsTop: ['To the left', 'center', 'To the right']
// };

// const BINARY_QST = {
//   id: 'mlllmlmmlm',
//   type: 'buttons',
//   cols: 2,
//   name: 'binary-base',
//   title: 'Yes or No? (binary)',
//   options: [
//     { id: 'dsm', value: 1, label: 'Yes' },
//     { id: 'dsj', value: 2, label: 'No' }
//   ],
//   validation: {
//     required: { value: true }
//   }
// };

// const RADIO_QST = {
//   id: 'lkokokokokoko',
//   type: 'radio',
//   name: 'radio-base',
//   variant: 'default', // available: default, buttons
//   title: 'Radio example',
//   options: [
//     { id: 'fsa', value: 'chocolate', label: 'Chocolate' },
//     { id: 'gsa', value: 'strawberry', label: 'Strawberry' },
//     { id: 'xsa', value: 'vanilla', label: 'Vanilla' }
//   ],
//   validation: {
//     required: { value: true }
//   }
// };

// const CHECKBOX_QST = {
//   id: 'huuhuhhuhuhu',
//   type: 'checkbox',
//   name: 'checkbox-base',
//   variant: 'default', // available: default, buttons
//   title: 'Checkbox example',
//   checkAll: true, // default: false
//   cols: 2, // default
//   options: [
//     { id: 'dva', value: 'mayo', label: 'Mayo' },
//     { id: 'dna', value: 'mustard', label: 'Mustard' },
//     { id: 'dua', value: 'ketchup', label: 'Ketchup' },
//     { id: 'daa', value: 'peperoni', label: 'Peperoni' }
//   ],
//   validation: {
//     required: { value: true }
//   },
//   helper: 'Using 2 cols to display options'
// };

// const SENTIMENT_QST = {
//   id: 'uiuiuuiuiui',
//   type: 'sentiment',
//   name: 'sentiment-base',
//   variant: 'default', // available: default, complete
//   title: 'How likely are you to answer this question?',
//   // options: [{ value: 1 }, { value: 2 }, { value: 3 }], // default values 1, 2, 3
//   validation: {
//     required: { value: true },
//     validate: value => value === 2 || 'Select the middle option' // custom validate fn
//   },
//   labelsTop: ['Bad', 'neutral', 'Good'],
//   labelsBottom: ['Bad', '', 'Good']
// };

// const SENTIMENT_COMP_QST = {
//   id: 'tyytytytyty',
//   type: 'sentiment',
//   name: 'sentiment-complete',
//   variant: 'complete', // available: default, complete
//   title: 'How do you feel right now',
//   // options: ['first', 'cueck', 'third', 'forth', 'fifth'], // default values 1, 2, 3, 4, 5
//   validation: {
//     required: { value: true }
//     // validate: value => value === 1 || 'Selecciona 1' // custom validate fn
//   },
//   labelsTop: ['Very Bad', 'neutral', 'Very Good'],
//   labelsBottom: ['', 'neutral', '']
// };

// const BUTTONS_QST = {
//   id: 'hyhyhyhhyyh',
//   type: 'buttons',
//   name: 'buttons-base',
//   title: 'Button options 1 column',
//   cols: 1, // default
//   options: [
//     { id: 'ggh', value: 1, label: 'one' },
//     { id: 'gfh', value: 2, label: 'two' },
//     { id: 'gdh', value: 3, label: 'tree' },
//     { id: 'gsh', value: 4, label: 'four' }
//   ],
//   validation: {
//     required: { value: true }
//   }
// };
// const BUTTONS2_QST = {
//   id: 'jujujujujujuj',
//   type: 'buttons',
//   name: 'buttons-base-2',
//   title: 'Button options 2 column',
//   cols: 2, // default
//   options: [
//     { id: 'ggj', value: 'mayo', label: 'Mayo' },
//     { id: 'ggk', value: 'mustard', label: 'Mustard' },
//     { id: 'ggl', value: 'ketchup', label: 'Ketchup' },
//     { id: 'ggx', value: 'peperoni', label: 'Peperoni' }
//   ],
//   validation: {
//     required: { value: true }
//   }
// };
// const BUTTONS4_QST = {
//   id: 'bnbbnbnbnbnbn',
//   type: 'buttons',
//   name: 'buttons-base-4',
//   title: 'Button options 4 colums',
//   cols: 4, // default
//   options: [
//     { id: 'aaw', value: 'item 1' },
//     { id: 'aas', value: 'item 2' },
//     { id: 'aad', value: 'item 3' },
//     { id: 'aaf', value: 'item 4' }
//   ],
//   validation: {
//     required: { value: true }
//   }
// };

// const BUTTONS_NPS_QST = {
//   id: 'vbvbvbvbvbbv',
//   type: 'buttons',
//   name: 'buttons-nps',
//   title: 'How likely are you to recommend PollmeApp to a friend?',
//   cols: 10, // default
//   options: [
//     { id: 'usd', value: 1 },
//     { id: 'uad', value: 2 },
//     { id: 'uqd', value: 3 },
//     { id: 'urd', value: 4 },
//     { id: 'utd', value: 5 },
//     { id: 'uhd', value: 6 },
//     { id: 'unj', value: 7 },
//     { id: 'unk', value: 8 },
//     { id: 'unc', value: 9 },
//     { id: 'unz', value: 10 }
//   ],
//   labelsBottom: ['Not at all likely', '', 'Extremely likely'],
//   validation: {
//     required: { value: true }
//   }
// };
// const TEXTAREA_NPS_QST = {
//   id: 'hsdfbkdj',
//   type: 'textarea',
//   name: 'textarea-nps',
//   title: 'Why **{{buttons-nps}}**?',
//   // title: responses => (
//   //   <>
//   //     Why <strong>{responses['buttons-nps']}</strong>?
//   //   </>
//   // ),
//   validation: {
//     // required: true,
//     required: { value: true },
//     maxLength: {
//       value: 140
//       // message: 'Max 140 caracteres' // JS only: <p>error message</p> TS only support string
//     }
//   },
//   isVisible: responses => !!responses['buttons-nps']
// };
// const BINARY_SHOW_QST = {
//   id: 'cvcvccvccfg',
//   type: 'buttons',
//   name: 'BINARY_SHOW',
//   title: 'Show next question?',
//   defaultValue: 1,
//   cols: 2,
//   options: [
//     { id: 'uno', value: 1, label: 'Yes' },
//     { id: 'dos', value: 2, label: 'No' }
//   ],
//   validation: {
//     required: { value: true }
//   },
//   helper: 'With defaultValue (controlling visibility logic of next question)'
// };

// const MATRIX_QST = {
//   id: 'vgyunjn',
//   type: 'matrix',
//   name: 'matrix-base',
//   title: 'Matrix question example',
//   options: [
//     {
//       id: 'ggt',
//       value: '1',
//       label: 'Very Slightly or Not at All'
//     },
//     {
//       id: 'gdt',
//       value: '2',
//       label: 'A Little'
//     },
//     {
//       id: 'gft',
//       value: '3',
//       label: 'Moderately'
//     },
//     {
//       id: 'gyt',
//       value: '4',
//       label: 'Quite a Bit'
//     },
//     {
//       id: 'gut',
//       value: '5',
//       label: 'Extremely'
//     }
//   ],
//   rows: [
//     {
//       value: 'PANAS_01',
//       label: 'Interested'
//     },
//     {
//       value: 'PANAS_02',
//       label: 'Distressed'
//     },
//     {
//       value: 'PANAS_03',
//       label: 'Excited'
//     },
//     {
//       value: 'PANAS_04',
//       label: 'Upset'
//     },
//     {
//       value: 'PANAS_05',
//       label: 'Strong'
//     },
//     {
//       value: 'PANAS_06',
//       label: 'Guilty'
//     },
//     {
//       value: 'PANAS_07',
//       label: 'Scared'
//     }
//   ],
//   validation: {
//     required: { value: true },
//     validate: value => allRowsRequired(value) || 'All rows are required'
//   },
//   helper: '**1** = Very Slightly or Not at All; **5** = Extremely',
//   isVisible: responses => responses.BINARY_SHOW === 1
// };

// const MATRIX2_QST = {
//   id: 'ububuhbubyg',
//   type: 'matrix',
//   name: 'matrix-simple',
//   title: 'Matrix simple',
//   options: [
//     { id: 'uno', value: 1 },
//     { id: 'dos', value: 2 },
//     { id: 'tres', value: 3 }
//   ],
//   rows: ['There', 'Was', 'A time'],
//   validation: {
//     required: { value: true }
//     // validate: value =>
//     //   allRowsRequired(value) || 'Por favor responde todas las filas'
//   }
//   // isVisible: responses => responses['BINARY_SHOW'] === 1
// };

// const RatingsPage = {
//   id: 'page04',
//   title: 'Page 4',
//   description: 'Page description',
//   elements: [RATING3_QST, RATING_QST, RATING7_QST, RATING10_QST]
// };
// const ButtonsPage = {
//   id: 'page05',
//   title: 'Page 5',
//   description: 'buttons page',
//   elements: [BUTTONS_QST, BUTTONS2_QST, BUTTONS4_QST]
// };
// const MatrixPage = {
//   id: 'page06',
//   title: 'Page 6',
//   description: 'logic and matrix',
//   elements: [BINARY_SHOW_QST, MATRIX_QST, MATRIX2_QST]
// };

// const DatesPage = {
//   id: 'page07',
//   title: 'Pag 7',
//   description: 'dates inputs',
//   elements: [DATE_INLINE__QST, DATE_QST, NATIVE_DATE_QST]
// };

// const NPSPage = {
//   id: 'page08',
//   // title: 'Pag 8',
//   // description: 'NPS example',
//   elements: [BUTTONS_NPS_QST, TEXTAREA_NPS_QST]
// };

// const PollModel = {
//   id: 'hfdsghvfds',
//   showStageNavigation: true, // default true
//   enableGoBack: true, // default true
//   stageNavigation: false, // default false
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: 'jasvdjgasd',
//       title: 'Page 1',
//       description: 'subtitle',
//       elements: [INPUT_QST, TEXTAREA_QST, NUMBER_QST, LIKERT_QST, SELECT_QST]
//     },
//     {
//       id: 'page02',
//       title: 'Page 2',
//       description: 'second description',
//       elements: [BINARY_QST, RADIO_QST, RATING_QST, SLIDER_QST, CHECKBOX_QST]
//     },
//     {
//       id: 'page03',
//       title: 'Page 3',
//       description: 'third description',
//       elements: [SENTIMENT_QST, SENTIMENT_COMP_QST]
//     },
//     RatingsPage,
//     ButtonsPage,
//     MatrixPage,
//     DatesPage,
//     NPSPage
//   ]
// };

// const SimpleRating = {
//   id: 'hfdsghvfds',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: false, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: '',
//       title: '',
//       description: '',
//       elements: [
//         {
//           id: 'ifbdgjkfdnkhe',
//           type: 'rating',
//           variant: 'heart', // default 'star' options: 'star', 'heart'
//           name: 'hearts-base',
//           title: 'How much do you *Love* us??',
//           showValues: true, // default true, as values under slider
//           ratingMax: 5, // range 3 to 10
//           validation: {
//             required: { value: true }
//           },
//           helper: 'Like pretty please?'
//           // labelsTop: ['To the left', 'center', 'To the right']
//         }
//       ]
//     }
//   ]
// };
// const SimpleSentiment = {
//   id: 'hfdsghvfds',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: false, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: '',
//       title: '',
//       description: '',
//       elements: [
//         {
//           id: 'tyytytytyty',
//           type: 'sentiment',
//           name: 'sentiment-complete',
//           variant: 'complete', // available: default, complete
//           title: 'How do you feel **right now**',
//           // options: ['first', 'cueck', 'third', 'forth', 'fifth'], // default values 1, 2, 3, 4, 5
//           validation: {
//             required: { value: true }
//             // validate: value => value === 1 || 'Selecciona 1' // custom validate fn
//           }
//           // labelsTop: ['Very Bad', 'neutral', 'Very Good'],
//           // labelsBottom: ['', 'neutral', '']
//         }
//       ]
//     }
//   ]
// };

// const MultiPage = {
//   id: 'hfdsghvfds',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: true, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: 'page rating',
//       title: 'Page 1',
//       description: 'About you:',
//       elements: [
//         {
//           id: 'ifbdgjkfdnkhe',
//           type: 'rating',
//           variant: 'star', // default 'star' options: 'star', 'heart'
//           name: 'star-base',
//           title: 'How much do you *like* us??',
//           showValues: true, // default true, as values under slider
//           ratingMax: 5, // range 3 to 10
//           validation: {
//             required: { value: true }
//           }
//           // helper: 'pretty please?'
//           // labelsTop: ['To the left', 'center', 'To the right']
//         }
//       ]
//     },
//     {
//       id: 'page03',
//       // title: 'Page 1',
//       // description: 'About you:',
//       elements: [
//         {
//           id: 'tyytytytyty',
//           type: 'sentiment',
//           name: 'sentiment-complete',
//           variant: 'complete', // available: default, complete
//           title: 'How do you feel **right now**',
//           // options: ['first', 'cueck', 'third', 'forth', 'fifth'], // default values 1, 2, 3, 4, 5
//           validation: {
//             required: { value: true }
//             // validate: value => value === 1 || 'Selecciona 1' // custom validate fn
//           }
//           // labelsTop: ['Very Bad', 'neutral', 'Very Good'],
//           // labelsBottom: ['', 'neutral', '']
//         }
//       ]
//     }
//   ]
// };

// const NPSModel = {
//   id: 'vbnbvn',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: false, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: 'page08',
//       // title: 'Pag 8',
//       // description: 'NPS example',
//       elements: [
//         {
//           id: 'vbvbvbvbvbbv',
//           type: 'buttons',
//           name: 'buttons-nps',
//           title: 'How _likely_ are you to recommend **PollmeApp** to a friend?',
//           cols: 10, // default
//           options: [
//             { id: 'usd', value: 1 },
//             { id: 'uad', value: 2 },
//             { id: 'uqd', value: 3 },
//             { id: 'urd', value: 4 },
//             { id: 'utd', value: 5 },
//             { id: 'uhd', value: 6 },
//             { id: 'unj', value: 7 },
//             { id: 'unk', value: 8 },
//             { id: 'unc', value: 9 },
//             { id: 'unz', value: 10 }
//           ],
//           validation: {
//             required: { value: true }
//           }
//           // labelsBottom: ['Not at all likely', '', 'Extremely likely'],
//         },
//         {
//           id: 'hsdfbkdj',
//           type: 'textarea',
//           name: 'textarea-nps',
//           // title: 'Why {{buttons-nps}}?',
//           title: 'Why??',
//           validation: {
//             required: {
//               value: false
//             }
//             // maxLength: {
//             //   value: 140,
//             //   message: 'Max 140 caracteres' // JS only: <p>error message</p> TS only support string
//             // }
//           }
//           // isVisible: responses => !!responses['buttons-nps']
//         }
//       ]
//     }
//   ]
// };

// const SimpleSelectors = {
//   id: 'vbnbvn',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: false, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: 'page08',
//       // title: 'Pag 8',
//       // description: 'NPS example',
//       elements: [
//         {
//           id: 'zwewrxrdtfc5465',
//           type: 'dropdown',
//           name: 'select-base',
//           title: 'Pick one form dropdown...',
//           options: [
//             { id: 'dft', value: 'chocolate', label: 'Chocolate' },
//             { id: 'fft', value: 'strawberry', label: 'Strawberry' },
//             { id: 'gft', value: 'vanilla', label: 'Vanilla' }
//           ],
//           // more select props as isCreatable, etc
//           validation: {
//             required: { value: true }
//           }
//         },
//         {
//           id: 'lkokokokokoko',
//           type: 'radio',
//           name: 'radio-base',
//           variant: 'default', // available: default, buttons
//           title: 'Radio example',
//           options: [
//             { id: 'fht', value: 'chocolate', label: 'Chocolate' },
//             { id: 'fjt', value: 'strawberry', label: 'Strawberry' },
//             { id: 'fit', value: 'vanilla', label: 'Vanilla' }
//           ],
//           validation: {
//             required: { value: true }
//           }
//         },
//         {
//           id: 'huuhuhhuhuhu',
//           type: 'checkbox',
//           name: 'checkbox-base',
//           variant: 'default', // available: default, buttons
//           title: 'Checkbox example',
//           checkAll: true, // default: false
//           cols: 2, // default
//           options: [
//             { id: 'ffk', value: 'mayo', label: 'Mayo' },
//             { id: 'ffl', value: 'mustard', label: 'Mustard' },
//             { id: 'ffi', value: 'ketchup', label: 'Ketchup' },
//             { id: 'ffo', value: 'peperoni', label: 'Peperoni' }
//           ],
//           validation: {
//             required: { value: true }
//           },
//           helper: 'Using 2 cols to display options'
//         }
//       ]
//     }
//   ]
// };

// const SatisfactionSurvey = {
//   id: 'fdrwesfsf',
//   lang: 'es',
//   enableGoBack: false, // default false
//   stageNavigation: false, // default false
//   showStageNavigation: true, // default true
//   // title: 'Preguntas!!',
//   // description: 'Cómo estuvo?',
//   pages: [
//     {
//       id: 'pagrewre08',
//       title: 'Satisfaction Survey Example',
//       description: 'Multi page example',
//       elements: [
//         {
//           id: 'ydirwesb89',
//           type: 'checkbox',
//           name: 'check-survey',
//           title: 'What do you find most attractive about our company?',
//           options: [
//             { id: 'aaw', value: 'Usability' },
//             { id: 'asw', value: 'Performance' },
//             { id: 'adw', value: 'Price' },
//             { id: 'afw', value: 'Customer Service' },
//             { id: 'agw', value: 'Uniqueness' }
//           ],
//           // more select props as isCreatable, etc
//           validation: {
//             required: { value: true }
//           }
//         }
//       ]
//     },
//     {
//       id: 'pawergeasdsa',
//       title: 'Satisfaction Survey Example',
//       description: 'Multi page example',
//       elements: [
//         {
//           id: 'ojdnrewk000',
//           type: 'radio',
//           name: 'radio-surv',
//           variant: 'default', // available: default, buttons
//           title: 'Overall, how satisfied or dissatisfied are you with our company?',
//           options: [
//             { id: 'aaw', value: 'Very Satisfied' },
//             { id: 'saw', value: 'Somewhat Satisfied' },
//             { id: 'daw', value: 'Neither satisfied nor dissatisfied' },
//             { id: 'faw', value: 'Somewhat dissatisfied' },
//             { id: 'gaw', value: 'Very dissatisfied' }
//           ],
//           validation: {
//             required: { value: true }
//           }
//         }
//       ]
//     },
//     {
//       id: 'nhbjbfdsps445hbsdakdfj',
//       title: 'Satisfaction Survey Example',
//       description: 'Multi page example',
//       elements: [
//         {
//           id: 'vbvb435vbvbvbbv',
//           type: 'buttons',
//           name: 'buttons-surv',
//           title: 'How well does our product meet your needs?',
//           cols: 1, // default
//           options: [
//             { id: 'aaw', value: 'Extremely well' },
//             { id: 'asw', value: 'Very well' },
//             { id: 'adw', value: 'Somewhat well' },
//             { id: 'afw', value: 'Not so well' },
//             { id: 'agw', value: 'Not at all well' }
//           ],
//           validation: {
//             required: { value: true }
//           }
//           // labelsBottom: ['Not at all likely', '', 'Extremely likely'],
//         }
//       ]
//     },
//     {
//       id: 'npshb5s43543dakdfj',
//       title: 'Satisfaction Survey Example',
//       description: 'Multi page example',
//       elements: [
//         {
//           id: 'vbvbvbvb5345vbbv',
//           type: 'buttons',
//           name: 'buttons-surv2',
//           title: 'How likely is it that you would recommend our company?',
//           cols: 10, // default
//           options: [
//             { id: 'usd', value: 1 },
//             { id: 'uad', value: 2 },
//             { id: 'uqd', value: 3 },
//             { id: 'urd', value: 4 },
//             { id: 'utd', value: 5 },
//             { id: 'uhd', value: 6 },
//             { id: 'unj', value: 7 },
//             { id: 'unk', value: 8 },
//             { id: 'unc', value: 9 },
//             { id: 'unz', value: 10 }
//           ],
//           validation: {
//             required: { value: true }
//           },
//           helper: '**1** - Not at all likely; **10** - Extremely likely'
//           // labelsBottom: ['Not at all likely', '', 'Extremely likely'],
//         }
//       ]
//     },
//     {
//       id: 'fsdf354',
//       title: 'Satisfaction Survey Example',
//       description: 'Multi page example',
//       elements: [
//         {
//           id: 'hsdfdshjbkdfbkdj',
//           type: 'textarea',
//           name: 'textarea-surv',
//           title: 'Do you have any other comments, questions, or concerns? ',
//           validation: {
//             // required: true,
//             required: { value: false }
//           }
//         }
//       ]
//     }
//   ]
// };

// const MODELS = [
//   { id: 'rating', model: SimpleRating, title: 'Simple Rating' },
//   { id: 'sentiment', model: SimpleSentiment, title: 'Simple Sentiment' },
//   { id: 'selectors', model: SimpleSelectors, title: 'Simple Selectors' },
//   { id: 'multi', model: MultiPage, title: 'Multi Pages' },
//   { id: 'nps', model: NPSModel, title: 'NPS Example' },
//   { id: 'satis-surv', model: SatisfactionSurvey, title: 'Satisfaction Survey' },
//   { id: 'all', model: PollModel, title: 'All items example' }
// ];
